// extracted by mini-css-extract-plugin
export const trackDetail = "track-detail-module--track-detail--bQAs6";
export const header = "track-detail-module--header--2VXhB";
export const titleColumn = "track-detail-module--title-column--c2ud8";
export const difficultyColumn = "track-detail-module--difficulty-column--TVoUW";
export const title = "track-detail-module--title--2j91G";
export const content = "track-detail-module--content--3xZZu";
export const surfaceFacts = "track-detail-module--surface-facts--1SR8A";
export const coreFacts = "track-detail-module--core-facts--p0Heu";